import React from "react";
import Header from "../components/landing/Header";
import Footer from "../components/landing/Footer";
import RequestForm from "../components/landing/RequestForm";
import SEO from "../components/SEO";

export default function EarlyAccess() {
  return (
    <>
      <SEO
        title="Request Early Access — Culmora OS"
        description="Tell us how you plan to use Culmora OS."
        path="/early-access"
      />
      <Header />
      <main id="main">
        <RequestForm headingLevel="h1" />
      </main>
      <Footer />
    </>
  );
}
